{
  "system": "system",
  "subtitle_one": "showing {{shown}} of {{count}} entry",
  "subtitle_other": "showing {{shown}} of {{count}} entries",
  "searchPlaceholder": "Search all fields",
  "searchLabel": "Search the log",
  "allActions": "all actions",
  "showFullDetails": "Show the full details",
  "loadFailed": "Could not load the log",
  "loadFailedHint": "{{reason}} Reading the log needs the audit:read permission.",
  "nothingFound": "Nothing found",
  "nothingFoundHint": "The search covers the action, the user, the target, the address, and the entry details. Try part of a word or clear the action filter.",
  "emptyTitle": "No entries yet",
  "emptyHint": "The log fills itself: sign-ins, changes to users and sites, connections to devices, and file operations all land here.",
  "loadMore": "Show more",
  "dialogLabel": "Log entry details",
  "escapeHint": "Escape — close",
  "column": {
    "at": "Time",
    "action": "Action",
    "user": "User",
    "target": "Target",
    "ip": "Address",
    "details": "Details"
  },
  "action": {
    "login": "sign-in",
    "loginFailed": "failed sign-in",
    "logout": "sign-out",
    "refreshReuse": "refresh token reused",
    "passwordChanged": "password changed",
    "userInvited": "user invited",
    "userUpdated": "user updated",
    "userDeactivated": "user disabled",
    "rolesChanged": "roles changed",
    "orgUpdated": "organization updated",
    "siteCreated": "site created",
    "siteUpdated": "site updated",
    "siteDeleted": "site deleted"
  }
}
